import { combineReducers } from "redux";
import whatsappAccountListReducer from "./whatsapp_account_list_reducer";

const accountReducer = combineReducers({
  allAccounts: whatsappAccountListReducer
});

export default accountReducer;
